__turbopack_context__.v({
  "area": "F0Aj_W_area",
  "autoTopup": "F0Aj_W_autoTopup",
  "axisLabel": "F0Aj_W_axisLabel",
  "axisTitle": "F0Aj_W_axisTitle",
  "baseKey": "F0Aj_W_baseKey",
  "baseLabel": "F0Aj_W_baseLabel",
  "bottom": "F0Aj_W_bottom",
  "controls": "F0Aj_W_controls",
  "cursor": "F0Aj_W_cursor",
  "description": "F0Aj_W_description",
  "details": "F0Aj_W_details",
  "equivalent": "F0Aj_W_equivalent",
  "estimate": "F0Aj_W_estimate",
  "graph": "F0Aj_W_graph",
  "graphKey": "F0Aj_W_graphKey",
  "gridLine": "F0Aj_W_gridLine",
  "heading": "F0Aj_W_heading",
  "line": "F0Aj_W_line",
  "links": "F0Aj_W_links",
  "operation": "F0Aj_W_operation",
  "point": "F0Aj_W_point",
  "presets": "F0Aj_W_presets",
  "projected": "F0Aj_W_projected",
  "rate": "F0Aj_W_rate",
  "rateAmount": "F0Aj_W_rateAmount",
  "rateUnit": "F0Aj_W_rateUnit",
  "rates": "F0Aj_W_rates",
  "saving": "F0Aj_W_saving",
  "section": "F0Aj_W_section",
  "selectedOperation": "F0Aj_W_selectedOperation",
  "shell": "F0Aj_W_shell",
  "slider": "F0Aj_W_slider",
  "total": "F0Aj_W_total",
  "volumeLabel": "F0Aj_W_volumeLabel",
});
